// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1216":"b46de41e731411d7","2888":"de29996d010588cd"}[chunkId] + ".css";
};